module.exports = __webpack_public_path__ + "img/financial-accounting-icon-hover.a0e16249.png";